export default {
  errorsRootKey: 'analytics/reports/operativereport',
  resource: 'analytics/reports/operativereport',
  actions: ['index', 'show', 'create', 'update', 'destroy'],

  exportOperativeReport(params = {}, options = {}) {
    return Vue.http.get(
      'analytics/reports/operativereport/export',
      {params, ...options}
    ).then(response => response.data)
  }
}
